/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ALLOWED_BENEFITS_FILE_UPLOAD_SIZE } from "Constants/BenefitConstants";
import {
  ALLOWED_FILE_SIZE_MB,
  INVALID_FILE,
  INVALID_FILE_SIZE,
  VALID_FILE_TYPES,
} from "Constants/ProfileConstants";

/**
 * validate the uploaded File.
 */
export const validateFileUpload = (event: React.ChangeEvent<HTMLInputElement>): string => {
  let response = "";
  const files = event.currentTarget.files;

  if (files) {
    const typeParts = files[0].type.split("/");
    const type = typeParts.length > 1 ? typeParts[1] : undefined;
    const size = files[0].size / 1024 / 1024; // Convert size to MB

    if (!type || !VALID_FILE_TYPES.includes(type)) {
      response = INVALID_FILE;
    } else if (size > ALLOWED_FILE_SIZE_MB) {
      response = INVALID_FILE_SIZE;
    }
  }

  return response;
};

/**
 * validate the uploaded File.
 */
export const validateBenefitsFileUpload = (event: React.ChangeEvent<HTMLInputElement>): string => {
  let response = "";
  const files = event.currentTarget.files;

  if (files) {
    const typeParts = files[0].type.split("/");
    const type = typeParts.length > 1 ? typeParts[1] : undefined;
    const size = files[0].size / 1024 / 1024; // Convert size to MB

    if (!type || !VALID_FILE_TYPES.includes(type)) {
      response = INVALID_FILE;
    } else if (size > ALLOWED_BENEFITS_FILE_UPLOAD_SIZE) {
      response = INVALID_FILE_SIZE;
    }
  }

  return response;
};

/**
 * convert Csv file ToBase64.
 */
export const convertCsvToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const binaryString = reader.result as string;

      //This line processes the binaryString to extract just the Base64 portion.
      const base64String = binaryString.replace("data:", "").replace(/^.+,/, "");
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};
